export default __webpack_public_path__ + "static/media/idle-glory.1f280e17.png";